import axios from "axios";
import { ICustomer } from "../../types";

export interface IGetCustomersParams {
    filters: {
        firstName?: string,
        lastName?: string,
        birthDate?: string,
        birthNation?: string,
        birthPlace?: string,
        residenceCountry?: string,
        fiscalCode?: string,
        email?: string,
        mobile?: string,
        drivingLicenseNumber?: string,
        vatNumber?: string;
        companyName?: string;
    } | null,
    start?: number,
    limit?: number
}

export const getCustomer = async (customerId: string): Promise<ICustomer> => {
    const response = await axios.get('/booking/instool/getCustomer',
        {
            params: {
                customerId
            }
        });
    return response.data;
}
